import { getElementChild, getElements } from '../Utility/Dom'
import { IS_ACTIVE } from '../Utility/State'

class Modules {
  readonly items: [] | NodeListOf<HTMLElement> = []
  private current: HTMLElement | null = null

  constructor() {
    this.items = getElements('modules-item')

    this.items.forEach((item: HTMLElement): void => {
      if (item.classList.contains(IS_ACTIVE)) {
        this.current = item
      }
    })
  }

  public init(): void {
    this.addEvents()
  }

  private addEvents(): void {
    this.items.forEach((item: HTMLElement): void => {
      const toggle = getElementChild(item, 'modules-toggle')

      if (toggle === null) return

      toggle.addEventListener('click', (): void => {
        this.setExpanded(item, !item.classList.contains(IS_ACTIVE))
      })
    })

    getElements('modules-link').forEach((link: HTMLElement): void => {
      link.addEventListener('click', (): void => this.setExpanded(this.current, true))
    })
  }

  private setExpanded(item: HTMLElement | null, isExpanded: boolean): void {
    const toggle = getElementChild(item, 'modules-toggle')
    const body = getElementChild(item, 'modules-body')

    if (item === null || toggle === null || body === null) return

    item.classList.toggle(IS_ACTIVE, isExpanded)
    toggle.setAttribute('aria-expanded', isExpanded ? 'true' : 'false')

    if (isExpanded) {
      body.removeAttribute('inert')
    } else {
      body.setAttribute('inert', '')
    }
  }
}

const modules = new Modules()
modules.init()
